export class StudentSummary{

    studentId: number;
	studentCode: string;
	maxOut: string;
    maxOutMonth: string;
	maxOutYear: number;

	agencyId: number;
	agencyName: string;
	projectId: number;
	projectName: string;
	uniqueId: string;

	studentName: string;
	gender:string;
	grade:string;
	nameOfGuardian:string;
	occupationOfGuardian:string;
	dateOfBirth:string;
	maxout:string;
	days:string;

	sponsorfirstName:string;
	sponsorCode:string;
	sponsorMiddleInitial:string;
	sponsorLastName:string;
	sponsorId:string
	
	parishId: number;
	parishName:string;
	parishCity:string;

	enrollmentId:number;
	effectiveDate: string;
	actualAmount: number;
	contributionAmount: number;
	miscAmount: number;
	createdBy: string;
	createdDate: string;
	sponseeId: number;
	stuMaxoutId: number;
}